import React, {Component} from 'react';
import * as messageConstants from '../../../shared/messages';
import * as samlConstants from '../../../constants/samlConstants';

export class UserGroupAttributesEnum extends Component {

  handleValueChange = (e) => {
    this.props.onUserGroupAttributesTableUpdate(e);
  }

  render() {
    return (
        <select
            name={this.props.cellData.type}
            value={this.props.cellData.value}
            id={this.props.cellData.id}
            onChange={this.handleValueChange}
            className="attributes-dropdown  form-control">
          <option
              value={samlConstants.CONTAIN}>{messageConstants.CONTAIN}</option>
          <option
              value={samlConstants.EQUALS}>{messageConstants.EQUALS}</option>
          <option
              value={samlConstants.START_WITH}>{messageConstants.START_WITH}</option>
        </select>
    );
  }
}

export default UserGroupAttributesEnum;
